<template>
  <div id="app" class="wrapper" style="padding-right: 2px; padding-left: 2px">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta">Meus dados</h1>

        <div class="modal-body">
          <form>
            <div id="listandoendereco" class="col-md-14">
              <div v-if="avancar == false">
                <div class="form-group">
                  <label class="col-md-4 control-label" for="nomecompleto"
                    >Nome Completo :
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="nomecompleto"
                      name="nomecompleto"
                      v-model="nomecompleto"
                      placeholder="Nome Completo"
                      class="form-control input-md"
                      required="required"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-4 control-label" for="telefone"
                    >Telefone :
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="telefone"
                      name="telefone"
                      v-model="telefone"
                      placeholder="(99) 99999-9999"
                      class="form-control input-md"
                      required="required"
                      maxlength="15"
                    />
                  </div>
                </div>
              </div>
              <div
                style="display: flex; justify-content: left; margin-left: 15px"
                v-if="avancar == false"
              >
                <button
                  style="
                    color: #fff;
                    border-color: #fff;
                    background-color: #006400;
                  "
                  type="button"
                  class="btn btn-dark"
                  @click="identificarNumero()"
                >
                  Avançar
                </button>
              </div>
              <div v-if="avancar == true">
                <div class="form-group">
                  <label class="col-md-10 control-label" for="formapagto"
                    >Forma de Pagamento :
                  </label>
                  <div class="col-md-10">
                    <select
                      class="form-control"
                      id="formapagto"
                      name="formapagto"
                      v-model="formapagto"
                    >
                      <option value="">Selecione a Forma de Pagamento</option>
                      <option value="Dinheiro">Dinheiro</option>
                      <option
                        v-for="bandeira of bandeiras"
                        :value="bandeira.nm"
                        :key="bandeira.cd"
                      >
                        {{ bandeira.nm }}
                      </option>
                    </select>
                    <div v-if="formapagto == 'Dinheiro'">
                      <label for="dinheiro">Troco para:</label>
                      <div style="display: flex">
                        <input
                          style="width: 110px"
                          type="number"
                          inputmode="decimal"
                          step=".01"
                          id="valorDinheiro"
                          value="valorDinheiro"
                          v-model="valorDinheiro"
                          class="form-control"
                          placeholder="100,00"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-md-10 control-label" for="tipo"
                    >Receber o Pedido :
                  </label>
                  <div class="col-md-10">
                    <select
                      class="form-control"
                      id="tipo"
                      name="tipo"
                      v-model="tipo"
                    >
                      <option value="Retirada" selected="selected">
                        Retirada
                      </option>
                      <option value="Entrega">Entrega</option>
                    </select>
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="estado"
                    >Estado :
                  </label>
                  <div class="col-md-10">
                    <select
                      class="form-control"
                      id="estado"
                      name="estado"
                      v-model="estado"
                    >
                      <option value="">Selecione o Estado (UF)</option>
                      <option v-for="(estado, idx) of estados" :key="idx">
                        {{ estado.uf }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="cidade"
                    >Cidade :
                  </label>
                  <div class="col-md-10">
                    <select
                      class="form-control"
                      id="cidade"
                      name="cidade"
                      v-model="cidade"
                      @change="getBairros(cidade.ibge)"
                    >
                      <option :value="cid" v-for="cid of cidades" :key="cid.cd">
                        {{ cid.nm }}
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  class="form-group"
                  v-if="tipo == 'Entrega' && cidade.nm != ''"
                >
                  <label class="col-md-4 control-label" for="estado"
                    >Bairro :
                  </label>
                  <div class="col-md-10">
                    <select
                      class="form-control"
                      id="bairro"
                      name="bairro"
                      v-model="bairro"
                    >
                      <option :value="bai" v-for="bai of bairros" :key="bai.cd">
                        {{ bai.nm }}
                      </option>
                    </select>
                    <div
                      style="margin: 5px"
                      id="taxa"
                      name="taxa"
                      v-if="bairro.nm != ''"
                    >
                      <div>Taxa de entrega: R${{ bairro.taxa }}</div>
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="rua">Rua : </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="rua"
                      name="rua"
                      v-model="rua"
                      placeholder="Rua"
                      class="form-control input-md"
                      required="required"
                    />
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="numero"
                    >Número :
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="numero"
                      name="numero"
                      v-model="numero"
                      placeholder="Número"
                      class="form-control input-md"
                      required="required"
                    />
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="complemento"
                    >Complemento :
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="complemento"
                      name="complemento"
                      v-model="complemento"
                      placeholder="Complemento"
                      class="form-control input-md"
                      required="required"
                    />
                  </div>
                </div>

                <div class="form-group" v-if="tipo == 'Entrega'">
                  <label class="col-md-4 control-label" for="referencia"
                    >Referência :
                  </label>
                  <div class="col-md-10">
                    <input
                      type="text"
                      id="referencia"
                      name="referencia"
                      v-model="referencia"
                      placeholder="Referência"
                      class="form-control input-md"
                      required="required"
                    />
                  </div>
                </div>
                <div class="form-group" v-if="cdAgendamento == 1">
                  <div class="col-md-10">
                    <div style="display: flex">
                      <input
                        type="checkbox"
                        id="agendamento"
                        value="agendamento"
                        v-model="checkedAgendamento"
                        style="accent-color: #000; margin-right: 8px"
                      />
                      <label for="agendamento"
                        >Deseja agendar seu pedido?
                      </label>
                    </div>
                    <div
                      v-if="checkedAgendamento.length > 0"
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: start;
                        flex-direction: column;
                      "
                    >
                      <input
                        style="padding: 8px"
                        type="datetime-local"
                        v-model="dataAgendamento"
                        id="dataencomenda"
                        name="dataencomenda"
                        class="custom-datetime"
                        :min="minDateTime"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div v-if="avancar == true">
          <label style="margin-left: 15px">Digite código de cupom:</label>
          <div style="display: flex; align-items: center; margin-left: 15px">
            <input
              style="width: 120px; margin-left: 5px"
              type="text"
              id="cupom"
              value="cupom"
              v-model="cupom"
              class="form-control"
              placeholder="cupom"
            />
            <button
              style="margin-left: 5px"
              class="btn btn-dark"
              @click="verificaCupom(cupom)"
            >
              Aplicar Cupom
            </button>
          </div>
          <br />
          <div
            style="
              display: flex; justify-content:space-between; align-items-center;
            "
          >
            <div
              style="display: block; align-self: flex-end; margin-left: 15px"
            >
              <button
                style="
                  color: #fff;
                  border-color: #fff;
                  background-color: #dc3545;
                "
                type="button"
                class="btn btn-dark"
                @click="recarregar()"
              >
                Voltar
              </button>
            </div>
            <div
              style="
                display: block;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="
                  display: grid;
                  align-items: center;
                  justify-content: center;
                  text-align: left;
                "
              >
                <label v-if="(bairro.taxa != '') | (descontoTotal != 0)"
                  >Valor dos produtos: R$ {{ buscavalor.toFixed(2) }}</label
                >
                <label v-if="bairro.taxa != ''"
                  >Valor da taxa de entrega: R$
                  {{ parseFloat(bairro.taxa).toFixed(2) }}</label
                >
                <label v-if="descontoTotal != 0"
                  >Valor do desconto: R$
                  {{ parseFloat(descontoTotal).toFixed(2) }}</label
                >
                <label v-if="bairro.taxa != ''"
                  >Valor total: R$
                  {{ (total + parseFloat(bairro.taxa)).toFixed(2) }}</label
                >
                <label v-if="bairro.taxa == ''"
                  >Valor total: R$ {{ total.toFixed(2) }}</label
                >
                <br />
              </div>
              <div
                style="display: flex; justify-content: flex-end"
                v-if="tipo === 'Retirada'"
              >
                <button
                  style="
                    color: #fff;
                    border-color: #fff;
                    background-color: #006400;
                  "
                  :disabled="isDisabled"
                  type="button"
                  class="btn btn-dark"
                  @click="salvarvenda(products, total, tipo)"
                >
                  Finalizar Pedido
                </button>
              </div>
              <div
                style="display: flex; justify-content: flex-end"
                v-else-if="tipo === 'Entrega'"
              >
                <button
                  style="
                    color: #fff;
                    border-color: #343a40;
                    background-color: #006400;
                  "
                  :disabled="isDisabled"
                  type="button"
                  class="btn btn-dark"
                  @click="salvarvenda(products, total, tipo)"
                >
                  Finalizar Pedido
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.form-control {
  padding: 0.25rem 0.25rem !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import Cupom from "../services/cupom";
import Venda from "../services/venda";
import Estado from "../services/estado";
import Bairro from "../services/bairro";
import Cidade from "../services/cidade";
import Endereco from "../services/endereco";
import Usuario from "../services/usuario";
import Inis from "../services/inis";
import Cardapio from "../services/cardapio";
import Swal from "sweetalert2";
import Bandeira from "../services/bandeira";
import moment from "moment";

export default {
  name: "FinalizadoSemCadastro",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      nomecompleto: "",
      telefone: "",
      formapagto: "",
      tipo: "Retirada",
      estado: "",
      cidade: {
        uf: "",
        nm: "",
        qtd_estab: "",
        ibge: "",
        dt_replica: "",
        hash: "",
      },
      bairro: {
        cd: "",
        nm: "",
        ibge: "",
        taxa: "",
        ativo: "",
        dt_replica: "",
      },
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      bairroCidade: [],
      endereco: [],
      listarendereco: false,
      cidades: "",
      estados: "",
      listaAdicionais: "",
      troco: "",
      valorDinheiro: "",
      cd: "",
      valorMinimo: 0,
      cupom: "",
      desconto: {},
      jaUsado: "",
      avancar: false,
      cupomVerificado: "",
      cuponsAplicados: [],
      descontoTotal: 0,
      cupomAux: false,
      estoque: "",
      bandeiras: [],
      idPixel: "",
      bairros: [],
      isDisabled: false,
      dataAgendamento: "",
      cdAgendamento: -1,
      checkedAgendamento: [],
      minDateTime: "",
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
    }),
    total() {
      var descontoVL;
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }

      this.valorTotal = somatorio;

      if (this.desconto.tipo == "V") {
        descontoVL = this.desconto.valor;
        this.descontoTotal =
          parseFloat(this.descontoTotal) + parseFloat(descontoVL);
        // console.log(this.descontoTotal, "V");
        return (this.valorTotal =
          this.valorTotal - parseFloat(this.descontoTotal));
      } else if (this.desconto.tipo == "P") {
        descontoVL = (this.valorTotal * parseFloat(this.desconto.valor)) / 100;
        this.descontoTotal = this.descontoTotal + descontoVL;
        // console.log(this.descontoTotal, "P");
        return (this.valorTotal = this.valorTotal - this.descontoTotal);
      } else {
        return this.valorTotal;
      }
    },
    buscavalor() {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },
    recarregar() {
      document.location.reload(true);
    },
    buscaTroco() {
      var troco;
      if (this.formapagto == "Dinheiro") {
        troco = parseFloat(this.valorDinheiro);
        if (troco == 0) {
          return (troco = "Não precisa de troco");
        } else {
          troco = parseFloat(troco).toFixed(2);
          this.valorTroco = troco;
          return troco;
        }
      } else {
        return (troco = "Não precisa de troco");
      }
    },
  },
  methods: {
    alertVazio() {
      Swal.fire({
        title: "Carrinho vazio, escolha um produto.",
        confirmButtonColor: "#000000",
      });
    },

    buscacodigo() {
      var mesge = "";
      var cd = "";
      var maisum = "1";

      if (this.vendaspedidos[0] && this.vendaspedidos[0].cd) {
        Venda.buscacodigo().then((resposta) => {
          this.vendaspedidos = resposta.data;
        });
        mesge = (
          parseFloat(this.vendaspedidos[0].cd) + parseFloat(maisum)
        ).toFixed(0);
        //mesge = (parseFloat(this.venda.cd) + parseFloat(maisum)).toFixed(0);
      }

      //alert(JSON.stringify(this.vendaspedidos[0].cd));

      return mesge;
    },
    listandoBandeiras() {
      Bandeira.listarbandeiras().then((resposta) => {
        this.bandeiras = resposta.data.filter((bandeira) => {
          if (bandeira.ativo == "1") {
            return bandeira;
          }
        });
        // alert(JSON.stringify(this.cidades));
      });
    },
    listandoCidade() {
      Cidade.listandoCidade().then((resposta) => {
        this.cidades = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    listandoEstado() {
      Estado.listandoEstado().then((resposta) => {
        this.estados = resposta.data;
        // alert(JSON.stringify(this.cidades));
      });
    },
    listandoInisEstoque() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
    },

    //listarpedidosvenda
    listarpedidosvenda(venda) {
      Venda.listarpedidosvenda().then((resposta) => {
        this.vendaspedidos = resposta.data;
        //alert(JSON.stringify(this.vendaspedidos[0]));
      });
    },

    //listarinisvalores
    listarinisvalores() {
      Inis.listarinisvalores().then((resposta) => {
        this.inis_valores = resposta.data;
        //alert(resposta.data);
      });
    },

    //listarinis
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((response) => {
        this.idPixel = response.data[0].vl;
        if (this.idPixel != "") {
          this.loadFacebookPixel(this.idPixel, "InitiateCheckout", "");
        }
      });
      var cd = "AGENDAMENTO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cdAgendamento = resposta.data[0].vl;
      });
    },
    listarInisValorMinimo() {
      var cd = "VL_MIN_PEDIDO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.valorMinimo = resposta.data[0].vl;
      });
    },
    async verificaCupom(cupom) {
      if (cupom == "") {
        Swal.fire({
          title: "Digite o cupom",
          confirmButtonColor: "#000000",
        });
      } else {
        await Cupom.verificacupom(cupom).then((resposta) => {
          this.cupomVerificado = resposta.data;
        });
        if (this.cupomVerificado == null) {
          Swal.fire({
            title: "Cupom inexistente",
            confirmButtonColor: "#000000",
          });
        } else {
          await Cupom.verificacupomusado(
            this.cdUsuario[0].cd,
            this.cupomVerificado[0].cd
          ).then((resposta) => {
            this.jaUsado = resposta.data;
          });
          console.log(this.cupomVerificado[0].repetivel);
          if (this.cupomVerificado[0].repetivel == "1") {
            this.jaUsado = null;
          }

          await Cupom.verificacupom(cupom).then((resposta) => {
            if (this.cupomAux == true) {
              Swal.fire({
                title: "Um cupom já foi aplicado",
                confirmButtonColor: "#000000",
              });
            } else if (resposta.data == null) {
              Swal.fire({
                title: "Cupom inexistente",
                confirmButtonColor: "#000000",
              });
            } else if (this.jaUsado != null) {
              Swal.fire({
                title: "Cupom já utilizado",
                confirmButtonColor: "#000000",
              });
            } else {
              if (parseFloat(resposta.data[0].vl_min) > this.total) {
                Swal.fire({
                  title:
                    "Valor mínimo de " +
                    resposta.data[0].vl_min +
                    " reais para usar o cupom",
                  confirmButtonColor: "#000000",
                });
              } else {
                this.desconto = {
                  tipo: resposta.data[0].tipo,
                  valor: resposta.data[0].valor,
                  cd: resposta.data[0].cd,
                  qtd: resposta.data[0].qtd,
                };
                Swal.fire({
                  title: "Cupom aprovado",
                  confirmButtonColor: "#000000",
                });
                /* this.cuponsAplicados.push(resposta.data[0].nm); */
                this.cupomAux = true;
              }
            }
          });
          this.jaUsado = "";
        }
      }
    },

    buscafone() {
      var cdf = "WHATSAPP";

      var msge = "";

      //se inis_valor tem valor dentro do indice 0

      //se tiver, tu vai pode acessar ele e o vl

      /* if (this.inis_valor[0] && this.inis_valor[0].vl) { */

      Inis.buscafone(cdf).then((resposta) => {
        this.inis_valor = resposta.data;
        // console.log(this.inis_valor, "this.inis_valor");
        this.msgBuscaFone = this.inis_valor[0].vl;
        //  console.log(this.msgBuscaFone, "this.msgBuscaFone");
      });

      // msge = this.inis_valor[0].vl;
      // console.log(msge, "msge");

      //alert(JSON.stringify(this.inis_valor[0].vl));
    },
    getMsgPedido() {
      const data = new Date(this.dataAgendamento);
      const dataFormatted = data.toLocaleDateString("pt-BR");
      const timeFormatted = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
      if (this.tipo == "Retirada") {
        this.msgRetirada = `Tempo agendado para retirada: ${dataFormatted} às ${timeFormatted}`;
      } else {
        this.msgEntrega = `Tempo agendado para entrega: ${dataFormatted} às ${timeFormatted}`;
      }
    },
    buscaentrega() {
      var cde = "TEMPO_ENTREGA";
      Inis.buscaentrega(cde).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgEntrega = this.inis_valores[0].vl;
      });
    },
    buscaretirada() {
      var cdr = "TEMPO_RETIRADA";

      Inis.buscaretirada(cdr).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgRetirada = this.inis_valores[0].vl;
      });
    },

    whatsapp(itens) {
      //console.log(itens[0].adicionaispergunta == 0);
      var retorno = "";
      var i;

      for (i = 0; i < itens.length; i++) {
        if (itens[i].adicionaispergunta != 0) {
          this.listaAdicionais = "";
          itens[i].adicionaispergunta.forEach((adicionais) => {
            this.listaAdicionais = this.listaAdicionais + adicionais.nm + ", ";
            /*  console.log(this.listaAdicionais) */
          });
          this.listaAdicionais = "- " + this.listaAdicionais;
        } else {
          this.listaAdicionais = "";
        }
        retorno =
          retorno +
          parseInt(itens[i].quantity) +
          "x " +
          itens[i].nm +
          this.listaAdicionais +
          "%0A"; //JSON.stringify(itens[i]);
      }
      return retorno;
    },

    menosqtd(p) {
      if (p.quantity >= "2") {
        p.quantity -= 1;
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
      }
    },
    somatorio() {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },

    somarqtd(p) {
      p.quantity += 1;
      //alert(JSON.stringify(index));
    },

    del(index) {
      this.products.splice(index, 1);
    },

    async identificarNumero() {
      if (this.idPixel != "") {
        this.loadFacebookPixel(this.idPixel, "CompleteRegistration", "");
      }

      const reNumero = /(\(?\d{2}\)?\s)?(\d{4,5}\d{4})/;

      if (this.nomecompleto == "") {
        Swal.fire({
          title: "Digite o seu nome completo",
          confirmButtonColor: "#000000",
        });
      } else if (this.telefone == "") {
        Swal.fire({
          title: "Digite o seu número de telefone",
          confirmButtonColor: "#000000",
        });
      } else if (
        reNumero.test(String(this.telefone.replace("-", ""))) == false
      ) {
        Swal.fire({
          title: "Digite um número no formato correto.",
          confirmButtonColor: "#000000",
        });
        return false;
      } else {
        //inserindo whatssap
        //  console.log("aqui 1");
        this.cdUsuario = await (await Usuario.getCdUsuario(this.telefone)).data;

        //se não tem whatssap, cria um
        if (this.cdUsuario == null) {
          var u = new Object();

          u.nomecompleto = this.nomecompleto;
          u.telefone = this.telefone;
          //verificar se fica normal
          //  console.log("aqui 2");
          await Usuario.cadastrarusuario(u);
          //  console.log("aqui 3");
          this.cdUsuario = await (await Usuario.getCdUsuario(u.telefone)).data;

          var e = new Object();

          e.estado = this.estado;
          e.cidade = this.cidade.nm;
          e.bairro = this.bairro.nm;
          e.rua = this.rua + ", n" + this.numero;
          e.complemento = this.complemento;
          e.referencia = this.referencia;
          e.ibge = this.ibge;
          e.cd = this.cdUsuario[0].cd;
          //  console.log("aqui 4");
          await Endereco.cadastrarendereco(e);
        } else {
          //atualiza
          var e = new Object();

          e.cd = this.cdUsuario[0].cd;
          e.rua = this.rua + ", n" + this.numero;
          e.bairro = this.bairro.nm;
          e.complemento = this.complemento;
          e.referencia = this.referencia;
          e.cidade = this.cidade.nm;
          e.estado = this.estado;
          e.ibge = this.ibge;
          var enderecoCadastrado = await Endereco.listandoEnderecos(
            this.cdUsuario[0].cd
          ).data;
          if (enderecoCadastrado) {
            await Endereco.atualizaendereco(e);
          } else {
            await Endereco.cadastrarendereco(e);
          }
        }
        this.avancar = true;
      }
    },
    loadFacebookPixel(idPixel, type, total) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      if (total == "") {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1`;
      } else {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1` +
          "&cd[value]=" +
          total +
          "&cd[currency]=BRL";
      }
      // img.src = 'https://www.facebook.com/tr?id=' + idPixel + `&ev=${type}&noscript=1` + '&cd[value]=' + total + '&cd[currency]=BRL';

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    async salvarvenda(products, total, tipo) {
      try {
        this.isDisabled = true;
        if (tipo === "Retirada") {
          if (!(await this.validarCamposRetirada())) {
            this.isDisabled = false;
            return false;
          }
        } else {
          if (!(await this.validarCamposEntrega())) {
            this.isDisabled = false;
            return false;
          }
        }
        if (!(await this.validarProdutos())) {
          this.isDisabled = false;
          return false;
        }
        if (
          !this.validateSelectedTime() &&
          this.checkedAgendamento.length > 0
        ) {
          await Swal.fire({
            title: "Horário inválido",
            confirmButtonColor: "#000000",
          });
          this.isDisabled = false;
          return false;
        }

        var v = new Object();

        v.mesa = null;
        v.serie = null;
        v.num_serie = null;
        v.total = this.somatorio();
        v.products = products;

        await this.identificarNumero();
        await Endereco.listandoEnderecos(this.cdUsuario[0].cd).then(
          (resposta) => {
            this.endereco = resposta.data;
          }
        );

        var u = new Object();

        if (this.tipo == "Retirada") {
          u.cd_endereco = 0;
        } else {
          u.cd_endereco = this.endereco[0].cd;
        }
        u.cd_usuario = this.cdUsuario[0].cd;

        await Usuario.alterarusuario(u).catch(function (error) {
          alert(error);
        });

        var v = new Object();

        v.cd_usuario = this.cdUsuario[0].cd;
        v.forma = this.formapagto;
        v.taxa = this.bairro.taxa;
        v.mesa = null;
        v.serie = null;
        v.num_serie = null;

        if (this.valorDinheiro == "") {
          v.troco = null;
        } else {
          v.troco = this.valorDinheiro;
        }
        v.total = this.somatorio();

        if (this.desconto.tipo == "V") {
          v.desconto = this.desconto.valor;
          //  console.log(v.desconto);
        } else if (this.desconto.tipo == "P") {
          v.desconto = (
            (parseFloat(v.total) * parseFloat(this.desconto.valor)) /
            100
          ).toFixed(2);
          //  console.log(v.desconto);
        } else {
          v.desconto = "0.00";
        }
        v.total = parseFloat(v.total).toFixed(2);
        v.products = products.map((produto) => {
          if (produto.unitario == "0") {
            produto.quantity = produto.peso;
          }
          return produto;
        });

        var c = new Object();

        c.cd_usuario = this.cdUsuario[0].cd;
        c.cd_cupom = this.desconto.cd;

        Cupom.registracupom(c);

        var cupomQtd = new Object();

        cupomQtd.cd_cupom = this.desconto.cd;
        cupomQtd.qtd = parseFloat(this.desconto.qtd) - 1;

        Cupom.atualizaqtd(cupomQtd);

        if (this.checkedAgendamento.length > 0) {
          v.dt = this.dataAgendamento.replace("T", " ");
          this.getMsgPedido()
        }

        await Venda.salvarvenda(v)
          .then(function (response) {
            Swal.fire({
              title: response.data,
              confirmButtonColor: "#000000",
            });
          })
          .catch(function (error) {
            alert(error);
          });
        if (this.idPixel != "") {
          this.loadFacebookPixel(
            this.idPixel,
            "Purchase",
            this.total.toFixed(2)
          );
        }
        if (this.estoque == "1") {
          for await (const produto of products) {
            await Cardapio.listarQtd(produto.cd).then((resposta) => {
              this.quantidade = resposta.data[0].estoque;
            });
            var e = new Object();

            e.cd = produto.cd;
            e.qtd = this.quantidade - produto.quantity;

            await Cardapio.alteraQtd(e).then((resposta) => {});
          }
        }

        if (this.tipo == "Retirada") {
          var win = window.open(
            "https://api.whatsapp.com/send?phone=" +
              this.msgBuscaFone +
              "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
              this.buscacodigo(this.vendaspedidos) +
              "*%0A---------------------------------------%0A%0A" +
              this.whatsapp(this.products) +
              "%0A* Total:%20R$%20" +
              this.total.toFixed(2) +
              "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
              this.buscaTroco +
              "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
              this.formapagto +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.nomecompleto +
              "*%0A" +
              this.telefone +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.tipo +
              "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
              this.msgRetirada +
              "*",
            "_blank"
          );
          if (win == null || win == undefined) {
            var win = window.location.assign(
              "https://api.whatsapp.com/send?phone=" +
                this.msgBuscaFone +
                "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
                this.buscacodigo(this.vendaspedidos) +
                "*%0A---------------------------------------%0A%0A" +
                this.whatsapp(this.products) +
                "%0A* Total:%20R$%20" +
                this.total.toFixed(2) +
                "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
                this.buscaTroco +
                "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
                this.formapagto +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.nomecompleto +
                "*%0A" +
                this.telefone +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.tipo +
                "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
                this.msgRetirada +
                "*"
            );
          }
          this.$store.commit("setZera", []);

          this.$router.push("/");
        } else if (this.tipo == "Entrega") {
          var win = window.open(
            "https://api.whatsapp.com/send?phone=" +
              this.msgBuscaFone +
              "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
              this.buscacodigo(this.vendaspedidos) +
              "*%0A---------------------------------------%0A%0A" +
              this.whatsapp(this.products) +
              "%0A*Produtos:%20R$%20" +
              parseFloat(this.total).toFixed(2) +
              "*%0A" +
              "%0A*Taxa de entrega:%20R$%20" +
              parseFloat(this.bairro.taxa).toFixed(2) +
              "*%0A" +
              "%0A*Total:%20R$%20" +
              (parseFloat(this.total) + parseFloat(this.bairro.taxa)).toFixed(
                2
              ) +
              "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
              this.buscaTroco +
              "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
              this.formapagto +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.nomecompleto +
              "*%0A" +
              this.telefone +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.tipo +
              "*%0A*Cidade:*%20" +
              this.cidade.nm +
              "%0A*Estado:*%20" +
              this.estado +
              "%0A*Bairro:*%20" +
              this.bairro.nm +
              "%0A*Rua:*%20" +
              this.rua +
              "%0A*Número:*%20" +
              this.numero +
              "%0A*Complemento:*%20" +
              this.complemento +
              "%0A*Referência:*%20" +
              this.referencia +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.msgEntrega +
              "*",
            "_blank"
          );
          if (win == null || win == undefined) {
            var win = window.location.assign(
              "https://api.whatsapp.com/send?phone=" +
                this.msgBuscaFone +
                "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
                this.buscacodigo(this.vendaspedidos) +
                "*%0A---------------------------------------%0A%0A" +
                this.whatsapp(this.products) +
                "%0A*Produtos:%20R$%20" +
                parseFloat(this.total).toFixed(2) +
                "*%0A" +
                "%0A*Taxa de entrega:%20R$%20" +
                parseFloat(this.bairro.taxa).toFixed(2) +
                "*%0A" +
                "%0A*Total:%20R$%20" +
                (parseFloat(this.total) + parseFloat(this.bairro.taxa)).toFixed(
                  2
                ) +
                "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
                this.buscaTroco +
                "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
                this.formapagto +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.nomecompleto +
                "*%0A" +
                this.telefone +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.tipo +
                "*%0A*Cidade:*%20" +
                this.cidade.nm +
                "%0A*Estado:*%20" +
                this.estado +
                "%0A*Bairro:*%20" +
                this.bairro.nm +
                "%0A*Rua:*%20" +
                this.rua +
                "%0A*Número:*%20" +
                this.numero +
                "%0A*Complemento:*%20" +
                this.complemento +
                "%0A*Referência:*%20" +
                this.referencia +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.msgEntrega +
                "*"
            );
          }

          this.$store.commit("setZera", []);

          this.$router.push("/");
        }
      } catch (err) {
        this.isDisabled = false;
      }
    },
    somatorio() {
      return this.products.reduce((acc, produto) => {
        const valorProduto = produto.peso
          ? parseFloat(produto.peso) * produto.vl
          : produto.vl * produto.quantity;
        return acc + valorProduto;
      }, 0);
    },
    async validarCamposEntrega() {
      const {
        products,
        formapagto,
        valorDinheiro,
        estado,
        cidade,
        bairro,
        rua,
        numero,
      } = this;
      const campos = [
        {
          campo: products,
          mensagem: "Por favor, escolha um produto do cardápio.",
        },
        {
          campo: formapagto,
          mensagem: "Por favor, selecione a forma de pagamento.",
        },
        { campo: estado, mensagem: "Por favor, selecione o seu estado." },
        { campo: cidade.nm, mensagem: "Por favor, digite a sua cidade." },
        { campo: bairro.nm, mensagem: "Por favor, digite o seu bairro." },
        { campo: rua, mensagem: "Por favor, digite a sua rua." },
        { campo: numero, mensagem: "Por favor, digite o número." },
      ];
      if (formapagto === "Dinheiro") {
        if (!valorDinheiro) {
          campos.push({
            campo: false,
            mensagem: "Por favor, digite valor em dinheiro.",
          });
        }
      }
      if(products.length === 0){
        campos.push({
          campo: false,
          mensagem: "Por favor insira um produto.",
        });
      }
      for (const { campo, mensagem } of campos) {
        if (!campo) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }
      return true;
    },
    async validarCamposRetirada() {
      const { products, nomecompleto, telefone, formapagto, valorDinheiro } =
        this;

      const campos = [
        {
          campo: products,
          mensagem: "Por favor, escolha um produto do cardápio.",
        },
        {
          campo: nomecompleto,
          mensagem: "Por favor, digite o seu nome completo.",
        },
        {
          campo: telefone,
          mensagem: "Por favor, digite o seu número de telefone.",
        },
        {
          campo: formapagto,
          mensagem: "Por favor, selecione a forma de pagamento.",
        },
      ];
      if (formapagto === "Dinheiro") {
        if (!valorDinheiro) {
          campos.push({
            campo: false,
            mensagem: "Por favor, digite valor em dinheiro.",
          });
        }
      }
      if(products.length === 0){
        campos.push({
          campo: false,
          mensagem: "Por favor insira um produto.",
        });
      }

      for (const { campo, mensagem } of campos) {
        if (!campo) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      return true;
    },
    async validarProdutos() {
      const { valorMinimo } = this;

      const campos = [
        {
          campo: valorMinimo,
          mensagem: "Por favor, selecione um produto.",
        },
      ];

      for (const { campo, mensagem } of campos) {
        if (!campo) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }
      if (parseFloat(this.valorMinimo) > this.somatorio()) {
        Swal.fire({
          title: "O valor mínimo de compra é: " + this.valorMinimo + " reais",
          confirmButtonColor: "#000000",
        });
        return false;
      }

      return true;
    },
    getBairros(cidade) {
      Bairro.listandoBairro(cidade).then((response) => {
        this.bairros = response.data.map((bairro) => {
          bairro.taxa = parseFloat(bairro.taxa).toFixed(2);
          return bairro;
        });
      });
    },
    setDate() {
      const currentDate = new Date();

      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");

      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");

      this.dataAgendamento = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    validateSelectedTime() {
      const currentTimeInt = Date.now();

      var selectedTime = JSON.parse(JSON.stringify(this.dataAgendamento));

      const selectedTimeInt = new Date(selectedTime).getTime();

      if (currentTimeInt > selectedTimeInt) {
        return false;
      }
      return true;
    },
    ...mapActions(["removeFromCart", "removeFromCartAd"]),
  },
  mounted() {
    this.setDate(),
      this.listandoInisEstoque(),
      this.listandoBandeiras(),
      this.listarInisValorMinimo(),
      this.listarinis(),
      this.listarinisvalores(),
      this.buscafone(),
      this.buscacodigo(),
      this.buscaretirada(),
      this.buscaentrega(),
      this.listarpedidosvenda(),
      this.listandoCidade(),
      this.listandoEstado();
  },
};
</script>
